// Spoločné nastavenie „Synchronizovať typy súborov" (SharePoint aj zdieľaný disk).
// Kategórie = dokumenty, ktoré Millada vie spracovať — ZRKADLO DOCUMENT_EXT v BE shared/core/file_types.py;
// iné súbory (aj obrázky a audio) backend pri synchronizácii ignoruje vždy.
// Jediný stav formulára = zoznam VYLÚČENÝCH podporovaných prípon (ukladá sa ako ExcludedFileExtensions);
// kategória (chip) aj jednotlivé prípony („Upresniť prípony") sú len pohľady naň — nemôžu si odporovať.

export const FILE_TYPE_PRESETS = [
  { key: 'pdf', icon: 'picture_as_pdf', extensions: ['.pdf'] },
  { key: 'word', icon: 'description', extensions: ['.doc', '.docx', '.docm', '.dot', '.dotx', '.dotm', '.rtf', '.odt'] },
  { key: 'excel', icon: 'table_chart', extensions: ['.xls', '.xlsx', '.xlsm', '.ods'] },
  { key: 'powerpoint', icon: 'slideshow', extensions: ['.ppt', '.pptx', '.pptm', '.potx', '.potm'] },
  { key: 'email', icon: 'mail', extensions: ['.msg'] },
  { key: 'text', icon: 'article', extensions: ['.txt', '.csv', '.md', '.json', '.log', '.html', '.htm', '.xml'] },
];

const SUPPORTED = FILE_TYPE_PRESETS.flatMap(preset => preset.extensions);

export const MB_PRESETS = [10, 25, 50, 100, 250, 500];

// v poradí kategórií (stabilný zoznam na uloženie aj súhrn)
const ordered = (excluded) => SUPPORTED.filter(extension => excluded.includes(extension));

// Uložené vylúčené prípony -> vylúčené PODPOROVANÉ prípony (.zip, .png, .xlsb, … sa zahodia — backend ich ignoruje vždy).
export const decodeExtensions = (values) => ordered(
  (values || []).map(value => {
    const normalized = String(value).trim().toLowerCase();
    return normalized && !normalized.startsWith('.') ? `.${normalized}` : normalized;
  }),
);

export const encodeExtensions = (excluded) => ordered(excluded);

// 'all' = synchronizujú sa všetky prípony kategórie, 'partial' = niektoré vynechané, 'none' = celá vynechaná
export const presetState = (preset, excluded) => {
  const hits = preset.extensions.filter(extension => excluded.includes(extension)).length;
  if (!hits) return 'all';
  return hits === preset.extensions.length ? 'none' : 'partial';
};

// Klik na kategóriu: celá zahrnutá -> vynechať celú; inak (vynechaná / čiastočne) -> zahrnúť všetky jej prípony.
export const togglePreset = (preset, excluded) => (presetState(preset, excluded) === 'all'
  ? ordered([...excluded, ...preset.extensions])
  : excluded.filter(extension => !preset.extensions.includes(extension)));

export const toggleExtension = (extension, excluded) => (excluded.includes(extension)
  ? excluded.filter(value => value !== extension)
  : ordered([...excluded, extension]));
